// import { canUseDOM } from 'dom-lib';

export const getDefaultTheme = () => {
  // if (!canUseDOM) {
  //   return 'default';
  // }
  if (matchMedia?.('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }
  return 'default'
}

export const THEME_KEY = 'theme'
export const THEME_DEFAULT = getDefaultTheme()
export const DIRECTION_KEY = 'direction'
export const DIRECTION_DEFAULT = 'ltr'
export const FONT_SIZE_KEY = 'fontSize'
export const FONT_SIZE_DEFAULT = '17'
export const MIN_FONT_SIZE = (parseInt(FONT_SIZE_DEFAULT, 10) - 2).toString()
export const MAX_FONT_SIZE = (parseInt(FONT_SIZE_DEFAULT, 10) + 5).toString()

const __DEV__ = process.env.NODE_ENV !== 'production'

// console.log('process.env', process.env)

export const getThemeId = (themeName, direction) => `theme-${themeName}-${direction}`
export const getThemeCssPath = (themeName, direction) =>
  `${__DEV__ ? `//localhost:3000` : ''}/css/theme-${themeName}${
    !__DEV__ && direction === 'rtl' ? '.rtl' : ''
  }.css`

export const readThemeName = () => {
  // if (!canUseDOM) {
  //   return THEME_DEFAULT;
  // }
  return localStorage.getItem(THEME_KEY) || THEME_DEFAULT
}
export const writeThemeName = (themeName) => {
  return localStorage.setItem(THEME_KEY, themeName)
}
export const readDirection = () => {
  // if (!canUseDOM) {
  //   return DIRECTION_DEFAULT;
  // }
  return localStorage.getItem(DIRECTION_KEY) || DIRECTION_DEFAULT
}
export const writeDirection = (dir) => localStorage.setItem(DIRECTION_KEY, dir)

export const readFontSize = () => {
  const _fontSize = localStorage.getItem(FONT_SIZE_KEY)
  if (isNaN(_fontSize) || _fontSize > MAX_FONT_SIZE || _fontSize < MIN_FONT_SIZE) {
    return FONT_SIZE_DEFAULT
  }
  return localStorage.getItem(FONT_SIZE_KEY) || FONT_SIZE_DEFAULT
}
export const writeFontSize = (size) => localStorage.setItem(FONT_SIZE_KEY, size)

export const readTheme = () => [readThemeName(), readDirection(), readFontSize()]

export const writeTheme = (themeName, direction) => {
  writeThemeName(themeName)
  writeDirection(direction)
}
